import {Locales} from '@netx/core-next/locales/utils/Locales';
import {AppToolsMenuSection} from './store/appToolItems';
import {AppCombinedMenuItemsSection} from './constants';

export const AppHomeLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.home'),
}));

export const AppContactLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.contact'),
	HELP_CENTER: i18n('i18n.helpCenter'),
}));

export const AppCombinedMenuSectionLabel = Locales((i18n) => ({
	[AppCombinedMenuItemsSection.MAIN]: '',
	[AppCombinedMenuItemsSection.TOOLS]: i18n('i18n.tools'),
	[AppCombinedMenuItemsSection.SYSTEM]: '',
	[AppCombinedMenuItemsSection.USER]: i18n('i18n.user'),
	[AppCombinedMenuItemsSection.SIGN_OUT]: '',
}));

export const AppToolsMenuSectionLabel = Locales((i18n) => ({
	[AppToolsMenuSection.TOOLS]: i18n('i18n.tools'),
}));
